import { render, staticRenderFns } from "./AssetDetail.vue?vue&type=template&id=71f91750&scoped=true"
var script = {}
import style0 from "./AssetDetail.vue?vue&type=style&index=0&id=71f91750&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71f91750",
  null
  
)

export default component.exports